import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import 'objectFitPolyfill'
import { Wrapper, BgVideo, BgImg, BgImgContainer, Title, Subtitle, Description, BannerContent, VideoWrapper } from './HeroBanner.style'
import { BannerButton, ButtonArrow } from '../../../shared/Buttons/Buttons.styles'
import ArrowRight from '../Icons/ArrowRight'
import Image from '../../../shared/Image'
import { getImageURL } from '../../../utils/siteHelper'

class HeroBanner extends Component {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      /* eslint-disable-next-line */
      objectFitPolyfill()
    }
  }

  render() {
    const {
      backgroundVideo,
      backgroundImage,
      image,
      heading,
      subheading,
      description,
      ctaText,
      ctaLink,
      isCarousel,
      fillScreen,
      alignContentLeft,
    } = this.props

    return (
      <Wrapper
        isCarousel={isCarousel}
        fillScreen={fillScreen}
        className={alignContentLeft ? 'alignLeft' : ''}
      >
        { backgroundVideo && backgroundImage
          ? <VideoWrapper src={getImageURL(backgroundImage)}><BgVideo hasObjectFit video={backgroundVideo} /></VideoWrapper>
          : backgroundImage
            ? <BgImgContainer><BgImg data-object-fit="cover" src={getImageURL(backgroundImage)} /></BgImgContainer>
            : null
        }
        <BannerContent className={alignContentLeft ? 'alignLeft' : 'wow fadeIn'}>
          { image
            ? (
              <Image
                src={image.imageFile.file.url}
                className="inlineImage"
                alt={image.altText}
                title={image.imageTitle}
              />
            )
            : ''
          }
          <div>
            <Title>{heading}</Title>

            { subheading ? (
              <Subtitle>{subheading}</Subtitle>
            ) : description && (
              <Description
                dangerouslySetInnerHTML={{
                  __html: description.childMarkdownRemark.html,
                }}
              />
            )}

            { ctaLink &&
              ctaText && (
              <BannerButton>
                <a href={ctaLink} aria-label={ctaText}>
                  {ctaText}
                  <ButtonArrow viewBox="0 0 12 21"><ArrowRight /></ButtonArrow>
                </a>
              </BannerButton>
            )}
          </div>
        </BannerContent>
      </Wrapper>
    )
  }
}

HeroBanner.propTypes = {
  backgroundVideo: PropTypes.shape({
    file: PropTypes.object,
  }),
  backgroundImage: PropTypes.shape({
    imageFile: PropTypes.object,
  }).isRequired,
  image: PropTypes.shape({
    imageFile: PropTypes.shape({
      file: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  }),
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string,
  description: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      html: PropTypes.string,
    }),
  }),
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
  isCarousel: PropTypes.bool,
  fillScreen: PropTypes.bool,
  alignContentLeft: PropTypes.bool,
}

HeroBanner.defaultProps = {
  backgroundVideo: {

  },
  image: '',
  subheading: '',
  description: '',
  ctaText: '',
  ctaLink: '',
  isCarousel: false,
  fillScreen: false,
  alignContentLeft: false,
}

export const HeroBannerFragment = graphql`
  fragment HeroBannerFragment on ContentfulHeroBanner {
    id
    heading
    subheading
    description {
      childMarkdownRemark {
        html
      }
    }
    ctaText
    ctaLink
    backgroundImage {
      ...ImageFragment
    }
    backgroundVideo {
      ...VideoFragment
    }
    image {
      ...ImageFragment
    }
    alignContentLeft
  }
`

export default HeroBanner
